<template>
  <v-container class="portfolio">
    <v-slide-x-reverse-transition mode="out-in">
      <v-row align="start" justify="center">
        <v-col v-for="(item, n) in portfolio" v-bind:key="n"
          xl="4" lg="6" md="8" sm="12" cols="12" class="pa-3"
        >
          <portfolio-card
            :name="item.name"
            :img="item.img"
            :info="item.info"
            :links="item.links"
          ></portfolio-card>
        </v-col>
      </v-row>
    </v-slide-x-reverse-transition>
  </v-container>
</template>

<script>
import PortfolioCard from '../components/PortfolioCard.vue'

export default {
  name: 'portfolio',
  components: {
    PortfolioCard
  },
  data: () => ({
    portfolio: [
      {
        name: 'TRI-GER',
        img: require('../assets/triger.png'),
        info: 'A bullet hell mixed with a color matching game that incorporates an 80’s inspired aesthetic arcade console experience that challenges the player to decide: turn back now or dive headfirst into an unhealthy relationship with failure in the pursuit of something as arbitrary as a high score.',
        links: [
          { color: 'secondary', url: 'https://github.com/JoeCharlesH/TRI-GER', text: 'Github' },
          { color: 'secondary', url: 'https://www.youtube.com/watch?v=hA9XOWfxQcQ', text: 'Video' },
          { color: 'secondary', url: 'https://joech.itch.io/tri-ger', text: 'Download' }
        ]
      },
      {
        name: 'Crypt Of En',
        img: require('../assets/crypt.png'),
        info: 'An Idle-Clicker Monster Fighting Game',
        links: [
          { color: 'secondary', url: 'https://cryptofengame.github.io/', text: 'Website' }
        ]
      },
      {
        name: 'LangTool',
        img: require('../assets/langtool.png'),
        info: 'A tool that allows you to use Google Spreadsheets as localization files.',
        links: [
          { color: 'secondary', url: 'https://github.com/JoeCharlesH/LangTool', text: 'Github' }
        ]
      },
      {
        name: 'Arcade Car Controller Demo',
        img: require('../assets/cardemo.png'),
        info: 'An arcade-style car controller demo with pixel art asthetics using a render texture and toon shader.',
        links: [
          { color: 'secondary', url: 'https://github.com/JoeCharlesH/Arcade-Car-Controller-Demo', text: 'Github' },
          { color: 'secondary', url: 'https://www.youtube.com/watch?v=bDCN2ee2C7o', text: 'Video' }
        ]
      },
      {
        name: 'Heat Map Tool',
        img: require('../assets/heatmap.png'),
        info: 'Scripts for generating a "heat map" that shows areas of high activity for game objects.',
        links: [
          { color: 'secondary', url: 'https://github.com/JoeCharlesH/HeatMap', text: 'Github' },
          { color: 'secondary', url: 'https://youtu.be/bk_9chUQI7g', text: 'Video' }
        ]
      },
      {
        name: 'Toon Shader',
        img: require('../assets/toon.png'),
        info: 'Toon Shader With Adjustable Lighting Ramp, Normal Mapping, Specular Mapping, Rim Lighting, and Darkness Vibrancy Adjustments',
        links: [
          { color: 'secondary', url: 'https://github.com/JoeCharlesH/ToonShader', text: 'Github' }
        ]
      }
    ]
  })
}
</script>
